import React, { useState } from 'react';
import { Quest } from '../types';

interface EditQuestModalProps {
  quest: Quest;
  onSave: (quest: Quest) => void;
  onClose: () => void;
}

const EditQuestModal: React.FC<EditQuestModalProps> = ({ quest, onSave, onClose }) => {
  const [title, setTitle] = useState(quest.title);
  const [description, setDescription] = useState(quest.description);

  const handleSave = () => {
    onSave({ ...quest, title, description });
  };

  return (
    <div 
      className="fixed inset-0 bg-black/60 flex items-center justify-center z-50"
      onClick={onClose}
      aria-modal="true"
      role="dialog"
    >
      <div 
        className="bg-white dark:bg-slate-800 rounded-xl shadow-2xl p-8 w-full max-w-lg border border-slate-300 dark:border-slate-700"
        onClick={e => e.stopPropagation()}
      >
        <h2 className="text-2xl font-bold text-slate-900 dark:text-slate-100 mb-4">Edit Quest</h2>
        <div className="space-y-4">
          <div>
            <label htmlFor="quest-title" className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">Title</label>
            <input
              id="quest-title"
              type="text"
              value={title}
              onChange={e => setTitle(e.target.value)}
              className="w-full bg-slate-100 dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md px-3 py-2 text-slate-900 dark:text-white focus:ring-2 focus:outline-none"
              style={{ '--tw-ring-color': 'var(--primary-500)' } as React.CSSProperties}
            />
          </div>
          <div>
            <label htmlFor="quest-description" className="block text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">Description</label>
            <textarea
              id="quest-description"
              value={description}
              onChange={e => setDescription(e.target.value)}
              rows={4}
              className="w-full bg-slate-100 dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md px-3 py-2 text-slate-900 dark:text-white focus:ring-2 focus:outline-none"
              style={{ '--tw-ring-color': 'var(--primary-500)' } as React.CSSProperties}
            />
          </div>
        </div>
        <div className="mt-6 flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-slate-200 dark:bg-slate-600 text-slate-800 dark:text-white font-semibold rounded-lg hover:bg-slate-300 dark:hover:bg-slate-500 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 text-white font-semibold rounded-lg transition-colors"
            style={{ backgroundColor: 'var(--primary-600)'}}
            onMouseOver={e => e.currentTarget.style.backgroundColor = 'var(--primary-700)'}
            onMouseOut={e => e.currentTarget.style.backgroundColor = 'var(--primary-600)'}
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditQuestModal;